import { editUrl } from './helpers/editURL'
import { WS } from './websocket'

export const createSocket = (
  WS_URL: any,
  receiveMessage: any,
  name: string,
  handleErrorText: any,
) => {
  WS_URL = editUrl(WS_URL)
  return new WS(WS_URL, receiveMessage, name, handleErrorText).start()
}
